<template>
  <v-form ref="form" class="">

    <BaseUtil ref="util" :pageLoading="pageLoading" />

    <v-row>
      <v-col cols="12" sm="12">
          Campos marcados com o ícone <v-icon color="warning">mdi-alert-circle</v-icon> são obrigatórios para Emissão da MDFe 
      </v-col>



      <v-col cols="12" sm="12" md="6">
        <MaskedTextField v-bind="getObject('plate')" :inputData.sync="entry.plate" mask-type="plate" label="Placa"
          autocomplete="off" :disabled="readOnly" :showAlertIcon="true" />
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete v-model="entry.plateStateId" v-bind="getObject('plateStateId')" label="UF Placa"
          :items="extraData.globalContext.allStates" item-value="id" item-text="shortName"
          @input="entry.plateState = extraData.globalContext.allStates.find(obj => obj.id == entry.plateStateId)"
          autocomplete="off" :disabled="readOnly" />
      </v-col>

      <v-col cols="6" sm="12" md="6">
        <MaskedTextField v-bind="getObject('tare')" :inputData.sync="entry.tare" mask-type="currency" label="Tara"
          suffix="KG" persistent-hint :disabled="readOnly" autocomplete="off" :showAlertIcon="true"></MaskedTextField>
      </v-col>

      <v-col cols="6" sm="12" md="6">
        <MaskedTextField v-bind="getObject('loadCapacity')" :inputData.sync="entry.loadCapacity" mask-type="currency"
          label="Capacidade total(KG)" persistent-hint :disabled="readOnly" autocomplete="off" :showAlertIcon="true">
        </MaskedTextField>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete v-model="entry.patrimonyCategoryId" v-bind="getObject('patrimonyCategoryId')" label="Categoria"
          :items="extraData.globalContext.allPatrimonyCategories" item-value="id" item-text="name"
          @input="entry.patrimonyCategory = extraData.globalContext.allPatrimonyCategories.find(obj => obj.id == entry.patrimonyCategoryId)"
          autocomplete="off" :disabled="readOnly" />
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-text-field v-model="entry.rntc" v-bind="getObject('rntc')" label="Número ANTT" autocomplete="off"
          :disabled="readOnly" />
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete v-model="entry.wheeledType" v-bind="getObject('wheeledType')" label="Tipo Rodado"
          :items="extraData.globalContext.allWheeledTypes" item-value="id" item-text="name" autocomplete="off"
          :disabled="readOnly">
          <template v-slot:append>
            <v-icon color="warning">mdi-alert-circle</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete v-model="entry.bodyType" v-bind="getObject('bodyType')" label="Tipo Carroceria"
          :items="extraData.globalContext.allBodyTypes" item-value="id" item-text="name" autocomplete="off"
          :disabled="readOnly">
          <template v-slot:append>
            <v-icon color="warning">mdi-alert-circle</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function (element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function () {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function () {
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function () {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
